import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconPercentCircle: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66663 13.9596C6.50663 13.9596 6.3466 13.8988 6.22493 13.7763C5.98077 13.5322 5.98077 13.1363 6.22493 12.8921L12.8916 6.22546C13.1358 5.9813 13.5316 5.9813 13.7758 6.22546C14.02 6.46963 14.02 6.86549 13.7758 7.10966L7.10913 13.7763C6.98663 13.8988 6.82663 13.9596 6.66663 13.9596ZM13.9583 12.293C13.9583 11.3738 13.2108 10.6263 12.2916 10.6263C11.3725 10.6263 10.625 11.3738 10.625 12.293C10.625 13.2121 11.3725 13.9596 12.2916 13.9596C13.2108 13.9596 13.9583 13.2121 13.9583 12.293ZM12.7083 12.293C12.7083 12.523 12.5216 12.7096 12.2916 12.7096C12.0616 12.7096 11.875 12.523 11.875 12.293C11.875 12.063 12.0616 11.8763 12.2916 11.8763C12.5216 11.8763 12.7083 12.063 12.7083 12.293ZM9.37496 7.70964C9.37496 6.79047 8.62746 6.04297 7.70829 6.04297C6.78913 6.04297 6.04163 6.79047 6.04163 7.70964C6.04163 8.6288 6.78913 9.3763 7.70829 9.3763C8.62746 9.3763 9.37496 8.6288 9.37496 7.70964ZM8.12496 7.70964C8.12496 7.93964 7.93829 8.1263 7.70829 8.1263C7.47829 8.1263 7.29163 7.93964 7.29163 7.70964C7.29163 7.47964 7.47829 7.29297 7.70829 7.29297C7.93829 7.29297 8.12496 7.47964 8.12496 7.70964ZM18.9583 10.0013C18.9583 5.0613 14.94 1.04297 9.99996 1.04297C5.05996 1.04297 1.04163 5.0613 1.04163 10.0013C1.04163 14.9413 5.05996 18.9596 9.99996 18.9596C14.94 18.9596 18.9583 14.9413 18.9583 10.0013ZM17.7083 10.0013C17.7083 14.2521 14.2508 17.7096 9.99996 17.7096C5.74913 17.7096 2.29163 14.2521 2.29163 10.0013C2.29163 5.75047 5.74913 2.29297 9.99996 2.29297C14.2508 2.29297 17.7083 5.75047 17.7083 10.0013Z"
      fill={color}
    />
  </svg>
);

export default IconPercentCircle;
